<template>
  <div class="flex flex-col mt-12 px-4 sm:px-0 text-white">
    <div class="text-24 leading-32 font-bold mb-3">Daha uzun vadeli bir astrolojik bakış ister misin?</div>
    <div class="text-md leading-20 font-normal mb-6">{{ year }} Seni Neler Bekliyor? Burç Yorumlarını Oku!</div>
    <div class="flex flex-row flex-wrap gap-4">
      <OLink
        v-for="(card, index) in cards"
        :key="index"
        :href="card.url"
        class="w-full h-full flex p-6 gap-6 rounded-[20px] hover:opacity-95 transition-opacity duration-200 justify-between"
        :style="{ background: card.background }"
        :class="{
          'w-full': index === cards.length - 1 && !isMobile,
          'flex-1': index !== cards.length - 1 && !isMobile,
        }"
      >
        <div class="flex flex-col justify-between items-start">
          <h3 class="text-white text-24 leading-32 font-semibold line-clamp-2">{{ card.title }}</h3>
          <p class="text-white text-md font-medium flex items-center gap-1">
            Oku
            <OIcon icon="right-white" class="w-4 h-4" />
          </p>
        </div>
        <OImage :src="card.image" :alt="card.title" class="object-contain top-4 right-4 w-[82px] h-[82px]" />
      </OLink>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useDevice } from '@/composables/useDevice';
import { OLink, OImage, OIcon } from '~/modules/common/components/ui';
import { getFrequencyDetails, getAvailableFrequencies } from '~/modules/astrology/utils/astrologyUtils';

export default defineComponent({
  components: {
    OLink,
    OImage,
    OIcon,
  },
  props: {
    horoscope: {
      type: String,
      default: 'aries',
    },
    frequency: {
      type: String,
      default: 'daily',
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const availableFrequencies = getAvailableFrequencies(props.frequency);
    const cards = computed(() => availableFrequencies.map((card) => getFrequencyDetails(card, props.horoscope)));
    const year = new Date().getFullYear();

    return { cards, getFrequencyDetails, year, isMobile };
  },
});
</script>

<style scoped>
.astrology-widget-card {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
